module.exports = __webpack_public_path__ + "static/media/table.496b3f6b.png";